import { render } from "./AlertComponent.vue?vue&type=template&id=b6d1f4a8&scoped=true"
import script from "./AlertComponent.vue?vue&type=script&lang=js"
export * from "./AlertComponent.vue?vue&type=script&lang=js"

import "./AlertComponent.vue?vue&type=style&index=0&id=b6d1f4a8&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-b6d1f4a8"]])

export default __exports__